// MobileNavbarProductsButton.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Stack } from '@mui/material';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ExpandLess from '@mui/icons-material/ExpandLess';
import { LinkButton } from '../../../components/buttons';
import NavbarProductsMenu from './NavbarProductsMenu';
import useNavbarProducts from '../../../hooks/useNavbarProducts';

const MobileNavbarProductsButton = ({ onClick, variant, ...rest }) => {
  const navigate = useNavigate();
  const options = useNavbarProducts();
  const containerStyles = {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  };
  const [open, setOpen] = useState(true);
  const toggle = () => setOpen(!open);
  const handleSelect = (to) => {
    onClick?.();
    navigate(to);
    setOpen(false);
  };

  return (
    <Stack gap="1.5rem">
      <LinkButton
        title="NUESTROS SERVICIOS"
        endIcon={open ? <ExpandLess /> : <ExpandMore />}
        onClick={toggle}
        variant={variant}
        {...rest}
      />

      {open && (
        <NavbarProductsMenu
          options={options}
          onSelect={handleSelect}
          variant="navbarProductsItemMobile"
          isMobile
          containerStyles={containerStyles}
        />
      )}
    </Stack>
  );
};

MobileNavbarProductsButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  variant: PropTypes.string.isRequired,
};

export default MobileNavbarProductsButton;
